import React, {useState} from "react";
import { Helmet } from "react-helmet";
import Heading from "components/Heading/Heading";
import {Product} from "data/data";
import groocLogoFull from "images/grooc-logo-full.jpg";
import ProductCard from "../../components/ProductCard";
import rightImg from "../../images/bags-studio-logo.svg";
import {loader} from "graphql.macro";
import {useQuery} from "@apollo/client";
import {sectionsQueryType, sectionsQueryTypeVars} from "../../graphql/types/sectons.types";
import mainBanner from "../../images/main-banner-1920.jpg";
import mainBannerPc from "../../images/banner-optimized.jpeg";
import NewCollectionSlider from "../../components/NewCollectionSlider/NewCollectionSlider";
import studioLogoImg from "../../images/bags-studio-sign.svg";
import groocBigBanner from "../../images/main-banner-big-1920.jpg";
import arrowsDownIcon from "../../images/arrows-down.svg";
import ReactPlayer from "react-player/lazy";
import aboutCompanyVideo from "../../video/about-company.mp4";
import {InView, useInView} from "react-intersection-observer";
import aboutCompany1 from "../../images/about-company/1.jpg";
import aboutCompany2 from "../../images/about-company/2.jpg";
import aboutCompany3 from "../../images/about-company/3.jpg";
import aboutCompany4 from "../../images/about-company/4.jpg";
import aboutCompany5 from "../../images/about-company/5.jpg";
import aboutCompany6 from "../../images/about-company/6.jpg";
import aboutCompany7 from "../../images/about-company/7.jpg";
import ModalPhotos from "../ProductDetailPage/ModalPhotos";
import ButtonPrimary from "../../shared/Button/ButtonPrimary";
import ButtonSecondary from "../../shared/Button/ButtonSecondary";
import Navigation from "../../shared/Navigation/Navigation";

interface sectionInterface {
    id: number;
    name: string;
    url?: string;

    items: Product[];

    video: {
        female: string | null;
        male: string | null;
    };
}

function PageHome() {

    const sectionsQuery = loader("../../graphql/sections.graphql");

    const { loading, data } = useQuery<sectionsQueryType, sectionsQueryTypeVars>(sectionsQuery);

    const [showFullCatalog, setShowFullCatalog] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);

    const [isOpenModalPhotos, setIsOpenModalPhotos] = useState(false);
    const [openFocusIndex, setOpenFocusIndex] = useState(0);

    const handleOpenModalPhotos = (index: number) => {
        setIsOpenModalPhotos(true);
        setOpenFocusIndex(index);
    };

    const handleCloseModalPhotos = () => setIsOpenModalPhotos(false);

    const { ref } = useInView({
        threshold: 0.5,
        trackVisibility: true,
        delay: 100,
        triggerOnce: true,
    });

    let catalogSectionCounter = 0;

    let sections: Array<sectionInterface> = [];

    if (!loading && data) {

        let item: Product;

        data.iblock.groocLandingSections.getElementList.map((section, key) => {
            let sect = {id: 0, name: '', items: [], url: '', video: {male: '', female: ''}};

            if (section.id) {
                sect.id = Number(section.id);
                sect.name = section.name;

                if (section.properties.sectionUrl) {
                    sect.url = section.properties.sectionUrl;
                }

                if (section.properties.videoFemale) {
                    sect.video.female = section.properties.videoFemale;
                }

                if (section.properties.videoMale) {
                    sect.video.male = section.properties.videoMale;
                }

                sections[sect.id] = sect;
            }

            return sections;
        });

        data.iblock.catalog.getElementList.map((element, index) => {

            if (element && element.properties.groocLandingSection && element.properties.groocLandingSection.id !== null) {

                item = {
                    id: element.id,
                    name: element.properties.marketplaceName ? element.properties.marketplaceName : element.name,
                    price: element.catalogProduct.prices[0].price,
                    image: '//store-bs.ru' + element.detailPicture.url,
                    productType: element.properties.productType ? element.properties.productType : '',
                    brand: element.properties.brand?.name,
                    vendorCode: element.properties.artnumber ? element.properties.artnumber : '',
                    description: '',
                    category: '',
                    tags: [''],
                    // link: '//store-bs.ru' + element.url,
                    link: element.properties.wildberriesLink ? element.properties.wildberriesLink.replace('https://', '//') : '//store-bs.ru' + element.url,
                };

                if (sections[element.properties.groocLandingSection.id]) {
                    sections[element.properties.groocLandingSection.id].items.push(item);
                }

                return item;

            } else {
                return element;
            }
        });
    }

    function scrollToCatalogBlock (catalogBlockId: string) {
        setShowFullCatalog(true);

        setTimeout(() => {
            let elementId = catalogBlockId.split('s_')[1];
            let element = document.getElementById(elementId);
            if (element !== null) {
                window.scrollTo(0, (element.parentElement ? element.parentElement.offsetTop : 0) + element.offsetTop - 48 - 50);
            }
        }, 300);
    }

  return (
    <div className="nc-PageHome relative"> {/* -mt-20 overflow-hidden */}
      <Helmet>
        <title>Grooc - школьные рюкзаки, ранцы, сумки, мешки для обуви и пеналы премиум-сегмента</title>
      </Helmet>

      {/* SECTION HERO */}

        <div className="container-fluid relative">
            <div
                className={`nc-SectionHero relative`}
                data-nc-id="SectionHero"
            >
                <div className="relative bg-transparent">
                    <img className="lg:hidden block max-h-full" src={mainBanner} alt="" />
                    <img className="hidden lg:block w-full max-h-full" src={mainBannerPc} alt="" />
                </div>
            </div>
        </div>

        <div className="hidden lg:flex items-center justify-center container-fluid"> {/* sticky top-0 z-40 bg-[rgba(255,255,255,0.95)] m-0 p-0 w-full */}
            <Navigation />
        </div>

        <div className="relative mt-[1.08rem] lg:mt-[1.5rem]">
            <NewCollectionSlider heading="Новая коллекция"/>
        </div>

        <div className={`nc-SectionHero relative container mt-[3.2rem] lg:px-[40px] xl:px-[60px] 2xl:px-[268px] lg:mt-[8.5rem]`} data-nc-id="SectionAbout1Index">
            <div className="flex flex-col justify-center items-center relative text-center space-y-7 lg:gap-y-[1rem]">

                <img className="max-w-[10.1rem] lg:max-w-[17.2rem] m-auto" src={groocLogoFull} alt="Эмблема Grooc" />

                <div className="text-[13.85px] lg:text-[18.3px] flex-grow max-w-full xl:max-w-5xl text-[#7e838d] space-y-[1.05rem] lg:space-y-[1.75rem] lg:leading-text-normal-pc leading-text-normal font-story">
                    <p>Волшебный и опасный мир цирка, мир «GROOC».</p>
                    <p>
                        Фантастическая обезьянка по имени Грук, откроет двери <br className="lg:hidden"/>
                        в безумный и невероятный мир, <br className="lg:hidden"/>
                        где прекрасные акробаты и невероятной красоты <br className="lg:hidden"/>
                        животные, творят чудеса, вопреки гравитации <br className="lg:hidden"/>
                        и законам природы …
                    </p>
                    <p>
                        Создавая уникальные дизайны, мы стремимся окунуть <br className="lg:hidden"/>
                        и детей и взрослых в наш мир магии! <br/>
                        Мы работаем по самым современным <br className="lg:hidden"/>
                        трендам и технологиям. <br/>
                        Прорабатываем все детали, что является <br className="lg:hidden"/>
                        отличительной особенностью нашего бренда. <br className="lg:hidden"/>
                        Новые технологии? Это к нам !
                    </p>
                    <p>
                        Добро пожаловать в забытый и сумасшедший мир чудес,<br className="lg:hidden"/>
                        страну «GROOC» , царство ранцев и рюкзаков.
                    </p>
                </div>

            </div>

            <img className="mt-[13px] max-w-[95px] max-h-[95px] lg:max-w-[115px] lg:max-h-[115px] relative left-full -translate-x-full lg:right-[3rem]" src={studioLogoImg} alt="Подпись Bags Studio" />

            <ButtonPrimary translate="relative left-1/2 -translate-x-1/2" className="mt-9 lg:mt-20 mx-auto block" href="/#l_about">
                Подробнее о компании
            </ButtonPrimary>
        </div>

        <div className="container-fluid lg:container mt-[42px] lg:mt-[84px]">
            <img className="2xl:max-w-[1240px]" src={groocBigBanner} alt="Баннер Grooc" />
        </div>

      {/*<div className="mt-24 lg:mt-32">*/}
      {/*  <DiscoverMoreSlider />*/}
      {/*</div>*/}

        <div id="catalog" className="relative container-fluid lg:container mt-[3.8rem] lg:mt-[6.6rem]">
          <Heading isCenter={true}>Каталог</Heading>

            <div className="flex flex-wrap flex-row place-items-center justify-center lg:mt-[2.4rem]"> {/* gap-x-4 gap-y-4 */}
                {sections.map((sectionItem, index) => {
                    if (sectionItem.items.length < 1) {return ;}
                    return (
                        <ButtonSecondary
                            onClick={() => scrollToCatalogBlock('#s_catalog_seriya_' + index)}
                            key={index}
                            className={`min-w-[90px] ml-2 mr-2 my-2 ${new RegExp(/[A-Za-z]/u).test(sectionItem.name) ? 'tracking-[0.3em]' : ''}`}
                            >
                            {sectionItem.name}
                        </ButtonSecondary>
                    );
                })}
            </div>

            {sections.map((sectionItem, index) => {
                if (sectionItem.items.length < 1) {return ;}
                catalogSectionCounter++;
                return <div
                    id={'catalog_seriya_' + index}
                    className={`catalog-section mt-[4rem] lg:mt-[5rem] ${catalogSectionCounter > 2 && !showFullCatalog ? 'hidden' : 'block'} ${catalogSectionCounter === 2 && !showFullCatalog ? 'catalog__demo-section relative h-[10.5rem] lg:h-52 overflow-hidden' : ''}`}
                    key={index}>
                    <Heading fontClass="text-[0.7rem] lg:text-[0.8rem] inline-flex items-center" className="mb-[0.8rem]" disableFlex={catalogSectionCounter === 2 && !showFullCatalog}>
                        <span className="bg-[#17171d] text-white text-[11px] lg:text-[12.5px] px-2.5 mr-[0.25rem] py-[2px]">GROOC</span> <span className={`${new RegExp(/[A-Za-z]/u).test(sectionItem.name) ? 'tracking-[0.3em]' : ''}`}>{sectionItem.name}</span> {/* pl-5 */ }
                    </Heading>

                    <div className="px-4 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-8 gap-y-[0.4rem] lg:mt-10">
                        {sectionItem.items.map((item, index) => (
                            <ProductCard data={item} key={index} />
                        ))}
                        {
                            catalogSectionCounter === 2 && !showFullCatalog ?
                                <div className="catalog__demo-shadow absolute top-1/2 left-0 w-full h-full"></div>
                            : <></>
                        }
                    </div>

                    {
                        sectionItem.video.female || sectionItem.video.male ?
                            <div className="flex flex-col lg:flex-row gap-2 lg:gap-5 mt-[0.7rem]">
                                {sectionItem.video.female ?
                                    <ReactPlayer key={1} className="w-full max-h-[213px] lg:max-h-full" width="100%" url={sectionItem.video.female} controls={true} />
                                    : <></>}
                                {sectionItem.video.male ?
                                    <ReactPlayer key={2} className="w-full max-h-[213px] lg:max-h-full" width="100%" url={sectionItem.video.male} controls={true} />
                                    : <></>}
                            </div>
                            : <></>
                    }
                </div>
            })}

            {catalogSectionCounter > 1 ?
                <div onClick={() => setShowFullCatalog(!showFullCatalog)} className="text-center mt-1 lg:mt-3">
                    <img className={`w-8 lg:w-9 m-auto cursor-pointer transition duration-300 ${showFullCatalog ? 'rotate-180' : ''}`} src={arrowsDownIcon} alt="Стрелки"/>
                    <ButtonPrimary className="mt-3 lg:mt-5">{!showFullCatalog ? 'Показать все модели' : 'Скрыть каталог'}</ButtonPrimary>
                </div>
                : <></>
            }
        </div>

        <div className="hidden mt-16 lg:mt-[5.9rem]" id="advantages">
            <Heading isCenter={true}>
                Наши преимущества
            </Heading>

            <div className="bg-black text-white mt-5 lg:mt-[1.55rem] inline-flex justify-center items-center w-full h-[225px] lg:h-[260px]"><p>БАННЕРЫ</p></div>
        </div>

        <div id="promos" className="mt-14 lg:mt-16">
            <Heading isCenter={true}>
                Акции
            </Heading>

            <div className="flex relative mt-10 lg:mt-[5.2rem] justify-center text-[#7e838d]">
                <p className="lg:max-w-4xl text-center lg:px-8 md:px-0 leading-text-normal lg:leading-text-normal-pc font-story text-[13.85px] lg:text-[18.3px]">
                    Цена указанная в данном каталоге (на сайте) розничная. <br/><br className="hidden lg:block" />
                    При оптовой закупке предусмотренная глубокая скидка, которая в свою очередь зависит от индивидуальных особенностей Заказа и форм сотрудничества,<br className="hidden lg:block" /> которая начинается от 40% и выше.<br/>
                    Для крупного опта предусмотрены отдельные условия сотрудничества.
                </p>
            </div>
        </div>

        <div className="container relative mt-[4.85rem] lg:mt-[14.3rem]" id="about">

          <div className="flex flex-col lg:gap-10 items-center justify-center relative text-center">
              <div className="">
                  <img className="w-[142px] lg:w-[194px] max-h-36" src={rightImg} alt="" loading="lazy" />
              </div>
              <div className="flex-grow xl:max-w-5xl mt-6 lg:mt-12 text-[#7e838d] font-story text-[13.85px] lg:text-[18.3px] leading-text-normal lg:leading-text-normal-pc">
                    <span className="block max-w-[330px] lg:max-w-xl mx-auto bg-[#e3e3e5] text-center text-[#020202] py-1">
                        Компания Bags-Studio - cтудия, которая создает.
                    </span>

                    <p className="text-center mt-4 lg:mt-[4.5rem]">
                        Наша миссия - создавать красивые, уникальные <br className="lg:hidden" />
                        дизайны и воплощать их в наших ранцах и рюкзаках <br className="lg:hidden" />
                        по самым современным трендам и технологиям. <br />
                        История компании Bags-Studio началась, <br className="lg:hidden" />
                        когда группа единомышленников, <br className="lg:hidden" />
                        движимых желанием создавать новые и <br className="hidden lg:block" /> необычные <br className="lg:hidden" />
                        вещи, объединилась, чтобы основать Bags-Studio.
                    </p>
                    <p className="text-center uppercase mt-7 lg:mt-16">
                        О НАШЕМ ДИЗАЙНЕ
                    </p>
                    <p className="text-center mt-4 lg:mt-[1.8rem]">
                        С самого начала мы стремились выработать свой <br className="lg:hidden" />
                        собственный уникальный стиль, <br className="hidden lg:block"/>сделать нашу продукцию <br className="lg:hidden" />
                        интересной, привлекательной и легко узнаваемой. <br className="lg:hidden" />
                        Мы контролируем весь процесс создания, <br className="hidden lg:block"/>что позволяет <br className="lg:hidden" />
                        высоко держать планку качества, а так же быть <br className="lg:hidden" />
                        уверенными, <br className="hidden lg:block"/>что абсолютно все наши товары отвечают <br className="lg:hidden" />
                        самым высоким требования и стандартам качества.
                    </p>
                    <p className="text-center uppercase mt-9 lg:mt-16">
                        ВЫСТАВКИ
                    </p>
                    <p className="text-center mt-5 lg:mt-[2rem]">
                        Мы являемся постоянными участками самых крупных в <br className="lg:hidden" />
                        стране выставок. <br className="hidden lg:block"/>Мы всегда следим за новыми <br className="lg:hidden" />
                        технологиями и тенденциями. <br />
                        За нашими плечами более 30 выставок.
                    </p>
              </div>
          </div>
        </div>

        <InView onChange={setIsPlaying} threshold={0.5}>
            <div className="mt-7 lg:mt-12 lg:max-w-[1240px] lg:mx-auto" id="videoCompany" ref={ref}>
                <ReactPlayer className="w-full lg:container" width="100%" height="auto" url={aboutCompanyVideo} playing={isPlaying} controls={true} attributes={{poster: aboutCompany3}} />
            </div>
        </InView>

        <div className="container mt-12 lg:max-w-[1240px] lg:mx-auto">
            <div id="aboutGallery" key={1} className="grid grid-rows-2 grid-cols-2 gap-x-3 gap-y-2 lg:grid-cols-3 lg:grid-rows-1 lg:gap-y-3 mb-2">
                <img src={aboutCompany1} key={'photo_' + 0} onClick={() => handleOpenModalPhotos(0)} className="object-cover min-h-full cursor-pointer" alt="" loading="lazy" />
                <img src={aboutCompany2} key={'photo_' + 1} onClick={() => handleOpenModalPhotos(1)} className="object-cover min-h-full cursor-pointer" alt="" loading="lazy" />
                <img src={aboutCompany3} key={'photo_' + 2} onClick={() => handleOpenModalPhotos(2)} className="object-cover min-h-full cursor-pointer" alt="" loading="lazy" />
                <img src={aboutCompany4} key={'photo_' + 3} onClick={() => handleOpenModalPhotos(3)} className="object-cover min-h-full cursor-pointer lg:hidden" alt="" loading="lazy" />
            </div>

            <div id="aboutGallery2" key={2} className="grid grid-rows-1 grid-cols-2 gap-x-3 gap-y-2 lg:grid-cols-3 lg:grid-rows-1 lg:gap-y-3 h-auto">
                <img src={aboutCompany5} key={'photo_' + 4} onClick={() => handleOpenModalPhotos(4)} className="object-cover min-h-full cursor-pointer" alt="" loading="lazy" />
                <div className="hidden lg:grid grid-cols-1 grid-rows-2 gap-y-3">
                    <img src={aboutCompany4} key={'photo_' + 5} onClick={() => handleOpenModalPhotos(3)} className="object-cover min-h-auto cursor-pointer hidden lg:inline-block" alt="" loading="lazy" />
                    <img src={aboutCompany7} key={'photo_' + 6} onClick={() => handleOpenModalPhotos(6)} className="object-cover min-h-auto cursor-pointer hidden lg:inline-block" alt="" loading="lazy" />
                </div>
                <img src={aboutCompany6} key={'photo_' + 7} onClick={() => handleOpenModalPhotos(5)} className="object-cover min-h-full cursor-pointer" alt="" loading="lazy" />
            </div>

            <ModalPhotos imgs={[aboutCompany1, aboutCompany2, aboutCompany3, aboutCompany4, aboutCompany5, aboutCompany6, aboutCompany7]} onClose={handleCloseModalPhotos} isOpen={isOpenModalPhotos} initFocus={openFocusIndex} uniqueClassName='nc-HomePage__modalPhotos' />
        </div>

        {/* <div id="delivery" className="mt-[5.8rem] lg:mt-[7.9rem]">
            <Heading isCenter={true}>
                Доставка
            </Heading>

            <div className="flex flex-col relative items-center justify-center text-[#7e838d] text-[13.85px] lg:text-[18.3px] leading-text-normal lg:leading-text-normal-pc font-story mt-12 lg:mt-[4.3rem]">
                <p className="max-w-4xl text-center md:px-0">
                    Заказы по России отгружаются только 100% предоплате.
                </p>
                <p className="max-w-4xl text-center mt-4 lg:mt-7 md:px-0">
                    Заказы оформленные до 15:00 текущего дня - отгружаются <br className="hidden lg:block" />в курьерскую службу, в текущий день. <br/>
                    Заказы <br /> оформленные после 15:00 - отгружаются в курьерскую <br className="hidden lg:block" />службу на следующий день.
                </p>
            </div>

            <ButtonPrimary className="mt-9 lg:mt-[4.75rem]" translate="relative left-1/2 -translate-x-1/2" href="//store-bs.ru/paysystem_and_delivery/" targetBlank={true}>Подробнее о доставке</ButtonPrimary>
        </div> */}

      </div>
  );
}

export default PageHome;
